var render = function (_h,_vm) {var _c=_vm._c;return _c('font-awesome-icon',{staticClass:"icon-bar",class:{
    'icon-bar-active': _vm.props.active
  },attrs:{"icon":"bars"}})}
var staticRenderFns = []

export { render, staticRenderFns }